export default __webpack_public_path__ + "static/media/about-hand-written-1.d93a203a.png";